import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { useTranslation } from 'react-i18next';
import Crowd from '@app/illu/Image/Crowd.svg';

const useStyles = createUseStyles((theme: Theme) => ({
  title: {
    ...theme.fonts.h3,
    whiteSpace: 'pre-line',
    marginTop: theme.marginBase * 5,
  },
  subtitle: {
    ...theme.fonts.body,
    marginTop: theme.marginBase * 5,
  },
  imageContainer: {
    textAlign: 'center',
  },
  image: {
    margin: 'auto',
    width: 148,
    height: 148,
  },
}));

export const OutOfQuota = () => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { t } = useTranslation();

  return (
    <div>
      <div className={classes.imageContainer}>
        <img src={Crowd} alt="Illustration" className={classes.image} />
      </div>
      <h1 className={classes.title}>
        {t('application.outOfQuota.title')}
      </h1>
      <p className={classes.subtitle}>{t('application.outOfQuota.subtitle')}</p>
    </div>
  );
};
